export const generateRemoteUrl = (searchQuery?: string, showOnlyActive?: boolean) => {
  const params = new URLSearchParams();

  if (searchQuery) {
    params.append("search", searchQuery.toLowerCase());
  }

  if (showOnlyActive) {
    params.append("get_deprecated", showOnlyActive ? "false" : "true");
  }

  return `exercises${params.toString() ? `?${params.toString()}` : ""}`;
};
